// extracted by mini-css-extract-plugin
export default {"card":"DraggableCard_card__HQEzi","controls":"DraggableCard_controls__tyc2U","header":"DraggableCard_header__kJbqq","content":"DraggableCard_content__OGwoV"};